import { IPost } from '_interfaces/post.interface';
import { EventItem } from 'components/EventItem';
import dayjs from 'dayjs';
import React from 'react';
import { getMimeTypeFromFileName, getRowIcon } from 'utils/helpers/fileCabinetHelpers';
import { isFileCommentPost } from 'utils/systemPostHelpers';

interface FileCommentPostProps {
  post: IPost;
  onClick?: () => void;
}

export const FileCommentPost: React.FC<FileCommentPostProps> = ({ post, onClick }) => {
  if (!post.systemMetadata || !isFileCommentPost(post.systemMetadata)) {
    return null;
  }

  const { systemMetadata, createdAt } = post;
  const { linkData } = systemMetadata;
  const fileName = linkData?.fileName || '';
  const displayName = fileName || 'Document';

  const mimeType = getMimeTypeFromFileName(fileName);
  const FileIcon = getRowIcon('file', mimeType);

  const nameSplit = post.createdBy?.displayName?.split(' ');
  const firstName = nameSplit?.[0] || '';
  const lastName = nameSplit?.[1] || '';
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`;
  const text = 'added a comment';
  const date = `${dayjs(createdAt).format('ll')} / ${dayjs(createdAt).format('LT')}`;

  return (
    <EventItem.Root>
      <EventItem.Header
        firstName={firstName}
        lastName={lastName}
        initials={initials}
        date={date}
        avatar={post.createdBy?.avatarUrl}
        text={text}
      />
      <EventItem.Content>
        <EventItem.Row>
          <EventItem.Circle>
            <FileIcon style={{ width: '24px', height: '24px', flexGrow: 0, flexShrink: 0 }} />
          </EventItem.Circle>
          <EventItem.Column>
            <EventItem.Text fontWeight={500} text={displayName} />
          </EventItem.Column>
        </EventItem.Row>
        <EventItem.ActionButton onClick={onClick} />
      </EventItem.Content>
    </EventItem.Root>
  );
};
